import Card from './Card';
import Checkbox from './Checkbox';
import InfoButton from './InfoButton';
import Item from './Item';
import ItemList from './ItemList';
import MultiLineText from './MultiLineText';
import Title from './Title';
import Text from './Text';
import Select from './Select';
import IntegerInput from './IntegerInput';
import TextEditor from './TextEditor';
import CopyMessageList from './CopyMessageList';
import CopyMessage from './CopyMessage';
import ComboSelectInteger from './ComboSelectInteger';
import ComboDuoSelectInteger from './ComboDuoSelectInteger';

export const componentMap = {
  card: Card,
  multiline_text: MultiLineText,
  title: Title,
  item_list: ItemList,
  item: Item,
  checkbox: Checkbox,
  info: InfoButton,
  text: Text,
  select: Select,
  integer: IntegerInput,
  'text-area': TextEditor,
  copy_message_list: CopyMessageList,
  copy_message: CopyMessage,
  combo_select_integer: ComboSelectInteger,
  combo_duo_select_integer: ComboDuoSelectInteger,
  copy_text: CopyMessage,
};
